/* The Clay Arts: Wholesale Inquiry page (fh-ws-*). Runs after fh-home.js and fh-pages.js.
   Ported from the reference wholesale.js. Written without backslashes on purpose. */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------------------------------------------------
     Ticker: repeat the list until it is wider than the screen, twice over, and slide it by half its
     width in a loop. Without this (no JS, or reduced motion) it stays a centred row.
     --------------------------------------------------------- */
  function initTickers(scope) {
    if (reduceMotion) return;
    Array.prototype.forEach.call(scope.querySelectorAll('.fh [data-fh-ws-ticker]:not(.is-running)'), function (ticker) {
      var list = ticker.querySelector('.fh-ws-ticker-list');
      if (!list) return;
      var track = document.createElement('div');
      track.className = 'fh-ws-ticker-track';
      ticker.insertBefore(track, list);
      track.appendChild(list);
      ticker.classList.add('is-running');
      var setWidth = list.getBoundingClientRect().width;
      if (setWidth > 0) {
        // Each half must cover the widest screen we expect, so the loop never shows a gap
        var perHalf = Math.max(1, Math.ceil(Math.max(window.screen.width, window.innerWidth, 1440) / setWidth));
        for (var k = 1; k < perHalf * 2; k++) {
          var copy = list.cloneNode(true);
          copy.setAttribute('aria-hidden', 'true');   // screen readers hear the points once
          track.appendChild(copy);
        }
        ticker.style.setProperty('--ws-ticker-time', Math.round(perHalf * setWidth / 38) + 's');   // about 38px a second
      }
    });
  }

  function boot() { initTickers(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initTickers(e.target); });
})();
